import borderTransformation from "../transformation/borderTransformation";
import { composeEnhancers, createStyledEnhancer } from "../helpers";
export var border = createStyledEnhancer({
  name: "border",
  transformation: borderTransformation
});
export var borderTop = createStyledEnhancer({
  name: "borderTop",
  transformation: borderTransformation
});
export var borderBottom = createStyledEnhancer({
  name: "borderBottom",
  transformation: borderTransformation
});
export var borderLeft = createStyledEnhancer({
  name: "borderLeft",
  transformation: borderTransformation
});
export var borderRight = createStyledEnhancer({
  name: "borderRight",
  transformation: borderTransformation
});
export var borderColor = createStyledEnhancer({
  name: "borderColor",
  keys: ["color", "palette"],
  workLikeGetByPathOnKeys: ["color", "palette", "palettes"]
});
export var borderRadius = createStyledEnhancer({
  name: "borderRadius"
});
export var borderTopRightRadius = createStyledEnhancer({
  name: "borderTopRightRadius"
});
export var borderBottomRightRadius = createStyledEnhancer({
  name: "borderBottomRightRadius"
});
export var borderTopLeftRadius = createStyledEnhancer({
  name: "borderTopLeftRadius"
});
export var borderBottomLeftRadius = createStyledEnhancer({
  name: "borderBottomLeftRadius"
});
export var borders = composeEnhancers(border, borderTop, borderBottom, borderLeft, borderRight, borderColor, borderRadius, borderTopRightRadius, borderBottomRightRadius, borderTopLeftRadius, borderBottomLeftRadius);